import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';

export async function resetQuoteRequests(
  quoteRequestIds: number[]
): Promise<Result<void, ApiError>> {
  try {
    await axios.post('/suggestions/quote-requests/reset', {
      quoteRequestIds,
    });
    return ok(undefined);
  } catch (error) {
    if (!isAxiosError(error)) {
      return err({ message: 'Failed to requote selected lanes' });
    }

    return err({
      message:
        error.response?.data?.message || 'Failed to requote selected lanes',
    });
  }
}
